<template>
  <v-text-field
    v-model="search"
    class="identifier-input"
    clear-icon="mdi-close-circle-outline"
    clearable
    dense
    hide-details
    :label="$t('headerSearchTypeFilter.search_in_list')"
    outlined
    style="direction: ltr"
    @keydown.enter="computedValue.text = search"
    @click:clear="clearSearch"
  >
    <template v-slot:prepend-inner>
      <v-card
        class="d-flex align-center px-2"
        color="grey lighten-2"
        flat
        height="40"
        width="fit-content"
      >
        <v-menu v-model="menu" bottom nudge-bottom="5" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :ripple="false"
              class="pa-0"
              style="text-transform: unset"
              text
            >
              <v-fade-transition mode="out-in">
                <v-icon v-if="!menu" key="down" class="ms-1"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else key="up" class="ms-1">mdi-chevron-up</v-icon>
              </v-fade-transition>
              <span
                v-if="!!translatedTypeItems && !!translatedTypeItems.length"
                >{{ translatedTypeItems[typeModel].text }}</span
              >
              <v-progress-circular
                v-else-if="loading"
                color="primary"
                indeterminate
                size="20"
                width="3"
              />
            </v-btn>
          </template>
          <v-list :disabled="loading" dense min-width="150">
            <v-list-item-group v-model="typeModel" mandatory>
              <template v-for="(item, i) in translatedTypeItems">
                <v-list-item :key="i" color="primary">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-card>
    </template>
    <template v-slot:append>
      <v-progress-circular
        v-if="loading && search && search.length >= 3"
        color="primary"
        indeterminate
        size="20"
        width="3"
      />
      <v-btn
        v-else
        class="mt-n1"
        icon
        small
        @click="computedValue.text = search"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "headerSearchTypeFilter",
  props: {
    value: Object,
    loading: Boolean,
  },
  data: () => ({
    search: "",
    menu: false,
    typeModel: 0,
    typeItems: [
      { value: "search", key: "search" },
      { value: "from", key: "start_from" },
    ],
  }),
  computed: {
    translatedTypeItems() {
      return this.typeItems.map((item) => ({
        ...item,
        text: this.$t(`headerSearchTypeFilter.${item.key}`),
      }));
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    typeModel(val) {
      this.computedValue.text = this.search;
      this.computedValue.type = this.typeItems[val].value;
    },
    value: {
      deep: true,
      handler(val) {
        this.search = val.text;
        this.typeModel = this.typeItems.findIndex(
          (item) => item.value === val.type
        );
      },
    },
  },
  methods: {
    ...mapActions("localstorage", []),
    clearSearch() {
      this.computedValue.text = "";
      this.typeModel = 0;
    },
  },
};
</script>

<style scoped>
.v-input.identifier-input >>> .v-input__slot {
  padding-left: 0 !important;
}
.v-input >>> .v-input__prepend-inner {
  margin: 0 !important;
  padding-left: 0;
  padding-right: 4px;
}
.qr-address-field >>> .v-input__append-inner {
  padding: 0 0 0 4px;
}
.select-dest >>> .v-input__slot {
  padding: 0 !important;
}
.select-dest >>> .v-input__append-inner {
  padding: 0 !important;
  margin: 0 !important;
}
.select-dest >>> .v-select__selection {
  font-size: small !important;
}
</style>
